import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cn } from "@/lib/utils"

/**
 * shadcn radix-nova Label primitive.
 *
 * Wraps `@radix-ui/react-label` so the `peer-disabled:` and `group-data-[disabled=true]:`
 * selectors resolve automatically when a sibling Input/Select/Textarea/Checkbox becomes
 * disabled (the underlying primitives carry the `peer` class — see `input.tsx`,
 * `select.tsx`, `textarea.tsx`, `checkbox.tsx`). The disabled label dims itself.
 */
const Label = React.forwardRef<
  React.ComponentRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    data-slot="label"
    className={cn(
      "text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
      className,
    )}
    {...props}
  />
))
Label.displayName = "Label"

export { Label }
